import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { I360Service } from 'src/Services/i360Service';
import { CheckAuth } from 'src/Services/utility.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-briefing-type-add-update',
  templateUrl: './briefing-type-add-update.component.html',
  styleUrls: ['./briefing-type-add-update.component.css']
})
export class BriefingTypeAddUpdateComponent implements OnInit {

  userID: any;
  BrieftypeMasterForm: FormGroup;
  SelectedTool: string;
  tokenKey: any;
  isSubmit: boolean = false;
  isEdit:boolean = false;
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  VisiblityType:number = 2;

  constructor(private readonly i360service: I360Service,
    private readonly _fb: FormBuilder, 
    private readonly checkAuth: CheckAuth, 
    private readonly activedRoute: ActivatedRoute, 
    private readonly router: Router, 
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.userID = this.sessionStorageService.getAdminUserId();
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() { 
    this.isSubmit = false;
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.BrieftypeMasterForm = this._fb.group({
      carrierCatId: 0,
      carrierCatName: ['', Validators.required],
      sortOrder: ['',Validators.required],
      isActive:[false],
      isArchive:[false]
    })
    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {
          this.isEdit = true;
          this.GetBriefTypeById(params['id']);
        }
      }
    });
  }

  GetBriefTypeById(carrierCatId: number) {
    this.i360service.GetBriefTypeById(this.tokenKey, parseInt(carrierCatId.toString())).subscribe(
      result => {
        if (result['status'] == 'Success') {
          this.BrieftypeMasterForm.patchValue({
            carrierCatId: result['briefing'].carrierCatId,
            carrierCatName: result['briefing'].carrierCatName,
            isActive : result['briefing'].isActive,
            isArchive:result['briefing'].isArchive,
            sortOrder: result['briefing'].sortOrder
          });
        }
      });
  }

  save() {
    this.isSubmit = true;
    let data = this.BrieftypeMasterForm.value;
    if (!this.BrieftypeMasterForm.valid||!data.carrierCatName.trim())
      return
    let value={
      carrierCatId:data.carrierCatId,
      carrierCatName:data.carrierCatName.trim(),
      sortOrder:data.sortOrder,
      isActive: data.isActive,
      isArchive:data.isArchive,
      visiblityType:2,
      createdBy:this.userID,

    }
    this.i360service.BriefingTypeAddUpdate(this.tokenKey, value).subscribe(
      result => {
        if (result['status'] == 'Success') {
          if(result['message'] !=""){
            this.showMessage(result['message'], 'Warning', 'warning')
          }else{

            if (data.carrierCatId > 0)
              this.showMessage('Briefing Type updated successfully', 'Success', 'success');
            else
              this.showMessage('Briefing Type saved successfully', 'Success', 'success');
            this.router.navigate(['/admin/'+this.SelectedTool+'/briefingType']);
          }
        }
        else {
          this.showMessage(result['status'], 'Error', 'error');
        }
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  cancelBriefType() {
    let navigation = '/admin/' + this.SelectedTool + '/briefingType';
    this.router.navigate([navigation]);
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

}
